import * as t from 'io-ts';
import {chain} from 'lodash';

import {makeSafeArrayType} from '../../types/arrayTypes';

/*
 * Runtime types.
 */

export const REmojiUsageEntry = t.type({
  shortcode: t.string,
  date: t.number,
});

export const REmojiUsage = makeSafeArrayType(REmojiUsageEntry);

/*
 * Types.
 */

export type EmojiUsageEntry = t.TypeOf<typeof REmojiUsageEntry>;
export type EmojiUsage = t.TypeOf<typeof REmojiUsage>;

/*
 * Constants.
 */

export const defaultEmojiUsage: EmojiUsage = [];

/** Keep at most 30 days worth of emoji usage history. */
const emojiUsageMaxAge = 30 * 24 * 60 * 60 * 1000;
/** Keep at most 100 emoji usage history entries. */
const emojiUsageMaxLength = 100;

/*
 * Conflict resolution.
 */

export function mergeEmojiUsage(left: EmojiUsage, right: EmojiUsage): EmojiUsage {
  let minDate: number | undefined;
  let length = 0;

  // Merge the two lists and keep the most recent entries.
  const result = chain(left)
    .concat(right)
    .sortBy(['date', 'shortcode'])
    // Using ['date', 'shortcode'] doesn't work for sortedUniqBy.
    .sortedUniqBy((entry) => `${entry.date}${entry.shortcode}`)
    .takeRightWhile((entry) => {
      if (minDate === undefined) {
        const maxDate = entry.date;
        minDate = maxDate - emojiUsageMaxAge;
      }

      return entry.date > minDate && length++ < emojiUsageMaxLength;
    })
    .value();

  return result;
}
